import PrestacionGrupoReglaCreate from './PrestacionGrupoReglaCreate';
import PrestacionGrupoReglaShow from './PrestacionGrupoReglaShow';

const indexGrupoRegla = {
    create: PrestacionGrupoReglaCreate,
    show: PrestacionGrupoReglaShow,
};

export default indexGrupoRegla;
